import React, { useState } from 'react';
import Swal from 'sweetalert2';
import fondo from '../assets/seguromedico.jpg';
import { useNavigate } from 'react-router-dom';
import '../styles/disenosegurosbase.css';
import FamilyMembers from '../components/FamilyMembers';

export default function SeguroDeGastosMedicosMayores() {
  const [genero, setGenero] = useState("");
  const [edad, setEdad] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [ingresos, setIngresos] = useState("");
  const [nombre, setNombre] = useState("");
  const [correo, setCorreo] = useState("");
  const [numero, setNumero] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [familyMembers, setFamilyMembers] = useState([]);


  const navigate = useNavigate();

  const validarDatos = () => {
    const emailRegex = /^[^\s@]+@(gmail|hotmail|outlook|yahoo)\.com$/i;
    const phoneRegex = /^\d{10}$/;

    if (!nombre || !edad || !genero || !codigoPostal || !ciudad || !ingresos || !correo || !numero) {
      Swal.fire('Campos incompletos', 'Por favor llena todos los campos obligatorios.', 'warning');
      return false;
    }
    if (isNaN(edad) || edad <= 0 || edad > 120) {
      Swal.fire('Edad no válida', 'Por favor ingresa una edad válida.', 'error');
      return false;
    }
    if (!emailRegex.test(correo)) {
      Swal.fire('Correo inválido', 'Utiliza un correo válido como gmail, hotmail, yahoo, outlook.', 'error');
      return false;
    }
    if (!phoneRegex.test(numero)) {
      Swal.fire('Número inválido', 'El número debe tener 10 dígitos.', 'error');
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validarDatos()) return;

    try {
      const response = await fetch(`https://ricardodiaztuasesorfinanciero.com/api/citasegurogastosmedicosmayores`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Nombre: nombre,
          Edad: edad,
          Genero: genero,
          CodigoPostal: codigoPostal,
          Ciudad: ciudad,
          Ingresos: ingresos,
          Personasextras: familyMembers.length > 0 ? JSON.stringify(familyMembers) : '[]',
          Correo: correo,
          Numero: numero
        }),
      });

      if (response.ok) {
        Swal.fire('¡Enviado!', 'Tus datos han sido enviados con éxito.', 'success');
        setNombre(""); setEdad(""); setGenero(""); setCodigoPostal(""); setCiudad(""); setIngresos(""); setFamilyMembers([]); setCorreo(""); setNumero("");
      } else {
        const result = await response.json();
        Swal.fire('Error', result.error || 'Algo salió mal', 'error');
      }
    } catch (error) {
      console.error("Error al enviar los datos", error);
      Swal.fire('Error de red', 'No se pudo conectar al servidor.', 'error');
    }
  };

  return (
    <>
      <button
        onClick={() => navigate('/')}
        className="seguro-back"
      >
        ← Regresar al Menú
      </button>
      <div className="seguro-container">
        <div className="seguro-left">
          <img src={fondo} alt="Seguro Médico" />
          <div className="seguro-overlay">
            <h1>Protege tu salud y la de tu familia</h1>
            <p>Llena este formulario y recibe asesoría personalizada en seguros médicos mayores.</p>
          </div>
        </div>
        <div className="seguro-form">
        <h2>Seguro de Gastos Médicos Mayores</h2>

        <label>Nombre:</label>
        <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />

        <label>Edad:</label>
        <input type="number" value={edad} onChange={(e) => setEdad(e.target.value)} />

        <label>Género:</label>
        <select value={genero} onChange={(e) => setGenero(e.target.value)}>
          <option value="">Selecciona</option>
          <option value="Masculino">Masculino</option>
          <option value="Femenino">Femenino</option>
        </select>

        <label>Código Postal:</label>
        <input type="number" value={codigoPostal} onChange={(e) => setCodigoPostal(e.target.value)} />

        <label>Ciudad:</label>
        <input type="text" value={ciudad} onChange={(e) => setCiudad(e.target.value)} />

        <label>Ingresos mensuales (aproximado):</label>
        <select value={ingresos} onChange={(e) => setIngresos(e.target.value)}>
          <option value="">Selecciona tu rango de ingresos</option>
          <option value="10,000 - 20,000">$10,000 - $20,000</option>
          <option value="20,000 - 30,000">$20,000 - $30,000</option>
          <option value="30,000 - 40,000">$30,000 - $40,000</option>
          <option value="40,000 - 50,000">$40,000 - $50,000</option>
          <option value="Más de 50,000">Más de $50,000</option>
        </select>

        <label>Correo electrónico:</label>
        <input type="text" value={correo} onChange={(e) => setCorreo(e.target.value)} />

        <label>Número de teléfono:</label>
        <input type="text" value={numero} onChange={(e) => setNumero(e.target.value)} />

        <FamilyMembers 
          onFamilyChange={setFamilyMembers}
          initialFamily={familyMembers}
        />

        <button onClick={handleSubmit} className="seguro-btn">Enviar</button>
                <p
          onClick={() => navigate("/pantallaCIT")}
          style={{
            marginTop: '15px',
            color: '#0c1f4d',
            textAlign: 'center',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '0.95rem'
          }}
        >
          ¿Quieres atencion mas directa? Agenda tu cita aquí!
        </p>
      </div>
    </div>
  </>
  );
}
